export enum enumColorType {
    None = 0,
    Anthracite = 1,
    Creme = 2,
    Zwart = 3,
    Elox = 4,
    Opaal = 5,
    Helder = 6,
    Warm = 7,
    Wit = 8,
    MillFinish = 9,
    Getint = 10,
}